<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn flat icon color="grey" @click="edit = true" v-if="userAuthClass">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <v-card-text>
        <div class="pb-2">
          <h5 class="subheading font-weight-regular text-capitalize">
            {{site.name}}
            <span v-if="site.location">, {{site.location}}</span>
          </h5>
          <div class="grey--text text-capitalize">
            <span class="clickable">{{site.project.name}}</span>
          </div>
        </div>
        <div class="pb-2">
          <h5 class="subheading font-weight-regular grey--text text--darken-1">{{site.contactEmail}}</h5>
        </div>
        <div class="pb-2">
          <h5 class="subheading font-weight-regular grey--text text--darken-1">{{site.contactPhone}}</h5>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn flat icon color="grey" :href="'tel:'+site.contactPhone" v-if="!!site.contactPhone">
          <v-icon>phone</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          color="grey"
          :href="'mailto:'+site.contactEmail"
          v-if="!!site.contactEmail"
        >
          <v-icon>mail</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text"  :subject="site" :time="site.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>


      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DRIVER DIALOG -->
    <v-dialog
      v-model="edit"
      max-width="700px"
      @keydown.esc="edit = false"
      lazy
      v-if="userAuthClass"
    >
      <edit-site :site="site" @close="edit = false"></edit-site>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      lazy
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{site.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteSite(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import SiteService from "@/services/requests/siteService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditSite from "@/components/sites/editSite";
export default {
  data() {
    return {
      edit: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteSite() {
      var site = this.site;
      SiteService.deleteSite(site.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("sites/deleteFromArrayStateByValue", {
            prop: "sites",
            value: site
          });
          this.snack({ text: "Site was deleted!", color: "yellow" });
        })
        .catch(err => {
          this.snackError();
        });
    }
  },
  props: {
    site: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.site.name.charCodeAt(0));
    },
    letter() {
      return this.site.name.charAt(0);
    }
  },
  components: {
    EditSite
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
